"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextNestedFieldLogic = void 0;
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
class TextNestedFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "textnestedfield";
        this.label = (0, intl_1.$t)(texts_1.nesetTextFieldText.nested_text);
        this.icon = "text";
        this.placeholder = (0, intl_1.$t)(texts_1.nesetTextFieldText.enter_value_here);
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
            contains: comparisons_1.contains,
            not_contains: comparisons_1.notContains,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
}
exports.TextNestedFieldLogic = TextNestedFieldLogic;
